/*
 *
 * RubiconePopup
 *
 * @version 1.0.0
 * @author Giorgia Cuozzo
 * @since 04-Feb-2025
 */

import React from 'react'
import PropTypes from 'prop-types'
import formattedMessage from './languageModule'
import Toggle from 'Hoc/ToggleComponent'
import MerchantModal from '@nexidigital/merchantmodal'
import './RubiconePopup.scss'
import { useMobileDetect } from 'Hoc/ListenerProvider'
import { openExternalUrl } from 'Components/Chatbot/getChatbotScriptBasedOnENV'
import { capitalizeAllString } from 'Utility/utils'

const RubiconePopup = (props) => {
  const { isMobile } = useMobileDetect()
  const navigateToMOS = () => {
    const { configurator, nbModelName, acquiring, product, vas } = props.infoPage?.actionUrl?.parameters || {}
    const hashedMerchantId = props.hashedMerchantId
    if (process.env.NODE_ENV !== 'production') {
      let BASEURL = `${props.infoPage?.actionUrl?.baseUrl}${props.infoPage?.actionUrl?.path}`
      if (process.env.NODE_ENV === 'development') {
        BASEURL = 'https://dev-nexi-it.nexiprivate.it/shop/cart/it/cart/business'
      }
      if (props.shops.length > 0) {
        if (isMobile) {
          if (props.selectedShop.voucher !== null) {
            openExternalUrl(
              `${BASEURL}?configurator=${configurator}&acquiring=${acquiring}&product=${product}&vas=${vas}&quantity=${props.selectedShop.quantity}&promoCode=${props.selectedShop.voucher}&nbModelName=${nbModelName}&shopDocId=${props.selectedShop.shopDocId}&utm_source=nb&utm_medium=link&utm_campaign=rubicone&utm_term=$app&mid=${hashedMerchantId}`
            )
          } else {
            openExternalUrl(
              `${BASEURL}?configurator=${configurator}&acquiring=${acquiring}&product=${product}&vas=${vas}&quantity=${props.selectedShop.quantity}&nbModelName=${nbModelName}&shopDocId=${props.selectedShop.shopDocId}&utm_source=nb&utm_medium=link&utm_campaign=rubicone&utm_term=$app&mid=${hashedMerchantId}`
            )
          }
        } else {
          if (props.selectedShop.voucher !== null) {
            openExternalUrl(
              `${BASEURL}?configurator=${configurator}&acquiring=${acquiring}&product=${product}&vas=${vas}&quantity=${props.selectedShop.quantity}&promoCode=${props.selectedShop.voucher}&nbModelName=${nbModelName}&shopDocId=${props.selectedShop.shopDocId}&utm_source=nb&utm_medium=link&utm_campaign=rubicone&utm_term=$web&mid=${hashedMerchantId}`
            )
          } else {
            openExternalUrl(
              `${BASEURL}?configurator=${configurator}&acquiring=${acquiring}&product=${product}&vas=${vas}&quantity=${props.selectedShop.quantity}&nbModelName=${nbModelName}&shopDocId=${props.selectedShop.shopDocId}&utm_source=nb&utm_medium=link&utm_campaign=rubicone&utm_term=$web&mid=${hashedMerchantId}`
            )
          }
        }
      }
    } else {
      if (props.infoPage && props.shops.length > 0) {
        if (isMobile) {
          if (props.selectedShop.voucher !== null) {
            openExternalUrl(
              `${props.infoPage.actionUrl.baseUrl}${props.infoPage.actionUrl.path}?configurator=${configurator}&acquiring=${acquiring}&product=${product}&vas=${vas}&quantity=${props.selectedShop.quantity}&promoCode=${props.selectedShop.voucher}&nbModelName=${nbModelName}&shopDocId=${props.selectedShop.shopDocId}&utm_source=nb&utm_medium=link&utm_campaign=rubicone&utm_term=$app&mid=${hashedMerchantId}`
            )
          } else {
            openExternalUrl(
              `${props.infoPage.actionUrl.baseUrl}${props.infoPage.actionUrl.path}?configurator=${configurator}&acquiring=${acquiring}&product=${product}&vas=${vas}&quantity=${props.selectedShop.quantity}&nbModelName=${nbModelName}&shopDocId=${props.selectedShop.shopDocId}&utm_source=nb&utm_medium=link&utm_campaign=rubicone&utm_term=$app&mid=${hashedMerchantId}`
            )
          }
        } else {
          if (props.selectedShop.voucher !== null) {
            openExternalUrl(
              `${props.infoPage.actionUrl.baseUrl}${props.infoPage.actionUrl.path}?configurator=${configurator}&acquiring=${acquiring}&product=${product}&vas=${vas}&quantity=${props.selectedShop.quantity}&promoCode=${props.selectedShop.voucher}&nbModelName=${nbModelName}&shopDocId=${props.selectedShop.shopDocId}&utm_source=nb&utm_medium=link&utm_campaign=rubicone&utm_term=$web&mid=${hashedMerchantId}`
            )
          } else {
            openExternalUrl(
              `${props.infoPage.actionUrl.baseUrl}${props.infoPage.actionUrl.path}?configurator=${configurator}&acquiring=${acquiring}&product=${product}&vas=${vas}&quantity=${props.selectedShop.quantity}&nbModelName=${nbModelName}&shopDocId=${props.selectedShop.shopDocId}&utm_source=nb&utm_medium=link&utm_campaign=rubicone&utm_term=$web&mid=${hashedMerchantId}`
            )
          }
        }
      }
    }
  }

  return (
    <Toggle>
      <MerchantModal
        ariaModalDescription=''
        ariaModalTitle=''
        title={formattedMessage.continueOnMos}
        description={formattedMessage.continueOnMosDescription(capitalizeAllString(props.infoPage?.card?.title))}
        onClose={() => props.actions.doHidePopup()}
        primaryAction={navigateToMOS}
        primaryButtonLabel={formattedMessage.continue}
        primaryButtonIcon='link'
      />
    </Toggle>
  )
}

RubiconePopup.propTypes = {
  actions: PropTypes.object,
  infoPage: PropTypes.object,
  selectedShop: PropTypes.object,
  hashedMerchantId: PropTypes.string,
  shops: PropTypes.array
}

RubiconePopup.defaultProps = {
  actions: {},
  infoPage: {},
  selectedShop: {},
  hashedMerchantId: '',
  shops: []
}

export default RubiconePopup
